import { useSuspenseQuery } from "@tanstack/react-query";
import { useIntegrationRecord } from "@/app/Settings/Settings/Hooks/useIntegrationRecord";
import { z } from "zod";

async function getVehicleCodes(apiKey: string, apiUrl: string) {
  const res = await fetch(
    new URL(`/api/v3/fleet-categories?accountId=${apiKey}`, apiUrl),
    {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    },
  );
  const json = await res.json();

  return vehicleValidator.parse(json);
}

async function getOfficeCodes(apiKey: string, apiUrl: string) {
  const res = await fetch(
    new URL(`/api/v3/sites?accountId=${apiKey}`, apiUrl),
    {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    },
  );
  const json = await res.json();

  return officeValidator.parse(json);
}

export function useJucyVehicleCodesList() {
  const integration = useIntegrationRecord();
  const metaData = metadataValidator.parse(integration.metadata);
  const apiKey = metaData["apiKey"];
  const apiUrl = metaData["apiUrl"];
  return useSuspenseQuery({
    queryKey: ["jucyVehicleCodes", apiKey, apiUrl],
    queryFn: () => {
      return getVehicleCodes(apiKey, apiUrl);
    },
  });
}

export function useJucyOfficeCodesList() {
  const integration = useIntegrationRecord();
  const metaData = metadataValidator.parse(integration.metadata);
  const apiKey = metaData["apiKey"];
  const apiUrl = metaData["apiUrl"];
  return useSuspenseQuery({
    queryKey: ["jucyOfficeCodes", apiKey, apiUrl],
    queryFn: () => {
      return getOfficeCodes(apiKey, apiUrl);
    },
  });
}

const metadataValidator = z
  .object({
    apiKey: z.string(),
    apiUrl: z.string(),
    region: z.enum(["nz", "au"]),
  })
  .catch(() => ({
    apiUrl: "",
    apiKey: "",
    region: "au" as const,
  }));

const vehicleValidator = z.array(
  z.object({
    code: z.string(),
    name: z.string(),
    vehicleDescription: z.string(),
    region: z.enum(["nz", "au"]),
  }),
);
const officeValidator = z.array(
  z.object({ siteCode: z.string(), countryCode: z.enum(["nz", "au"]) }),
);
